module.exports = __webpack_public_path__ + "static/media/monastery-from-behind.b8478374.jpg";